// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3w8ov","right":"styles_right__1_7mW"};